import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0, 78 45, 39 90, 0 45"
        />
        {/* E harfi için yeni path */}
        <path
          d="M30,30 L50,30 L50,35 L35,35 L35,45 L48,45 L48,50 L35,50 L35,61 L50,61 L50,66 L30,66 Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
